import React, { useState, useEffect } from "react";
import styled from "styled-components";

import EuropaStarten from "./animations/europastarten";
import FuehlenStarten from "./animations/fuehlenstarten";
import HamsternStoppen from "./animations/hamsternstoppen";
import KlimakriseStoppen from "./animations/klimakrisestoppen";
import KopfstandStarten from "./animations/kopfstandstarten";
import KreativitaetStarten from "./animations/kreativitaetstarten";
import MotorStarten from "./animations/motorstarten";
import MotorStoppen from "./animations/motorstoppen";
import Neustarten from "./animations/neustarten";
import SmombiesStoppen from "./animations/smombiesstoppen";
import SpaltungStoppen from "./animations/spaltungstoppen";
import StilleStoppen from "./animations/stillestoppen";
import UpdateStarten from "./animations/updatestarten";
import WachstumStarten from "./animations/wachstumstarten";
import WachstumStoppen from "./animations/wachstumstoppen";
import WeiterDenken from "./animations/weiterdenken";
// import WeiterHaltungZeigen from "./animations/weiterhaltungzeigen";
import WeiterHelfen from "./animations/weiterhelfen";
import WeiterLernen from "./animations/weiterlernen";
import WeiterStreiten from "./animations/weiterstreiten";
import WeiterTesten from "./animations/weitertesten";
import WeiterZoomen from "./animations/weiterzoomen";

// keys named like the slugs
const animations = {
  EuropaStarten,
  FuehlenStarten,
  HamsternStoppen,
  KlimakriseStoppen,
  KopfstandStarten,
  KreativitaetStarten,
  MotorStarten,
  MotorStoppen,
  Neustarten,
  SmombiesStoppen,
  SpaltungStoppen,
  StilleStoppen,
  UpdateStarten,
  WachstumStarten,
  WachstumStoppen,
  WeiterDenken,
  WeiterHelfen,
  WeiterLernen,
  WeiterStreiten,
  WeiterTesten,
  WeiterZoomen,
};

const Background = styled.img`
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const StaticLayers = styled(Background)`
  z-index: ${(props) => props.zIndex};
`;

// Making sure we're animating based on the image ratio, not on it's parent
const AspectRatio = styled.div`
  position: relative;
  overflow: hidden;
  background-color: white;
  &:after {
    content: "";
    display: block;
    padding-bottom: 122.4%; /* ratio of the 1920 x 2350 image */
  }
`;

const Cover = ({ cover, id, card, play, nextAnimation }) => {
  const animation = animations[id];

  useEffect(() => {
    if (nextAnimation) {
      const image = new Image();
      image.src = cover.background.lg;
    }
  }, [nextAnimation]);
  return (
    <div className="articleImage">
      <AspectRatio>
        {/* <Background src={card ? cover.background.sm : cover.background.lg} alt={cover.alt} /> */}
        <Background src={cover.background.lg} alt={cover.alt} />
        {cover.layers &&
          cover.layers.map((layer, i) => (
            <StaticLayers
              src={card ? layer.src.sm : layer.src.lg}
              key={i}
              zIndex={layer.zIndex}
            />
          ))}
        {React.createElement(animation, { cover: cover, play: play })}
      </AspectRatio>
    </div>
  );
};

export default Cover;
